import { z } from 'zod';
import { uuid } from './posting.js';
/**
 * Die Antwortverträge der Periodenendpunkte — `V-vertrag3` (2026-08-29).
 *
 * `apps/api/src/periods/periods.service.ts` führte `PeriodView`/`ClosedPeriod`
 * bislang als eigene Formen; der OpenAPI-Erzeuger blieb an `GET
 * /api/v1/periods` und `POST /api/v1/periods/:id/close` deshalb
 * `[UNGEKLÄRT]`.
 */
/** Eine Periode, wie sie nach aussen geht — `GET /api/v1/periods`. */
export const periodViewSchema = z
    .object({
    id: uuid,
    year: z.number().int(),
    month: z.number().int().min(1).max(12),
    status: z.enum(['open', 'closed']),
    closedAt: z.string().nullable(),
    closedBy: uuid.nullable(),
    createdAt: z.string(),
    createdBy: uuid,
})
    .strict();
/**
 * Die Antworthülle von `GET /api/v1/periods` — `{ periods: [...] }`. Der Umschlag lebt neben seinem
 * Elementschema, damit Server und Oberfläche dieselbe Hülle prüfen (Handbuch §3.969).
 */
export const periodListResponseSchema = z.object({ periods: z.array(periodViewSchema).readonly() }).strict();
/**
 * Eine festgeschriebene Periode im Ergebnis des Abschlusses —
 * `POST /api/v1/periods/:id/close`.
 *
 * `backfilled` unterscheidet die angeforderte Periode von den Monaten, die
 * der Abschluss nebenbei angelegt hat.
 */
export const closedPeriodSchema = periodViewSchema
    .extend({ backfilled: z.boolean() })
    .strict();
//# sourceMappingURL=periods.js.map